import feather from 'feather-icons';

window.addEventListener('DOMContentLoaded', () => {
    feather.replace();
});
